<template>
<div class="chapter">
<div class="inner_page">
<div id="eBook4280-5.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-6">PART I</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42805.vue?615e11ae